import { useMutation } from '@apollo/client';
import GET_LANDING_PAGE from '../../pages/Landing/useLandingPage/GET_LANDING_PAGE';
import useBusinessConfiguration from '../useBusinessConfiguration';
import CREATE_SUBSCRIPTION from './CREATE_SUBSCRIPTION';
var useCreateSubscription = function (shouldRefetch) {
    if (shouldRefetch === void 0) { shouldRefetch = false; }
    var _a = useBusinessConfiguration(), tenant = _a.tenant, program = _a.program;
    // Define CMS Content Names
    var landingPageContentName = "".concat(tenant, "RefreshmentsLandingPage");
    return useMutation(CREATE_SUBSCRIPTION, {
        errorPolicy: 'all',
        refetchQueries: shouldRefetch
            ? [
                {
                    query: GET_LANDING_PAGE,
                    variables: {
                        program: program,
                        landingPageContentName: landingPageContentName,
                    },
                },
            ]
            : [],
    });
};
export default useCreateSubscription;
